import styled from 'styled-components';

const BaseLink = styled.a`
    cursor: pointer;
    display: block;
    text-decoration: none;
    transition: all 0.2s linear;
    &:focus {
        outline: rgb(0, 0, 0) thin dotted;
        transition: none;
    }
`;

export default BaseLink;
